import ESContext from "../ESContext";
import AnalyticsUtil from "../graphs/AnalyticsUtil";
import {YAxisFormatNumber, YAxisFormatTime} from "../graphs/GraphFormatting";
import {formatGermanDate, formatSeconds} from "../../common/TimeUtil";
import HighChartsGraph from "../graphs/HighChartsGraph";
import CachedGraphV2 from "../graphs/CachedGraphV2";
import OutlierUtil from "../OutlierUtil";
import StatisticsUtil from "../StatisticsUtil";

class AdLatency_Daily {
    static getUUID() {
        return "0aaaa330-b2cd-4e86-a552-c3defce6fe2f";
    }

    static getProps() {
        return [
            {id:"title",name:"Title", type:"string"},
            {id:"group",name:"Group by", type:"string"},
            {id:"filterOutlier", name: "Filter Outlier", type:"boolean"},
            {id:"filter",name:"Filter", type:"filterTags"}
        ];
    }

    static getGraphSize() {
        return 1;
    }

    static getHeightRatio() {
        return "50%";
    }

    static calcAdLatency(_latencyData, _filterOutlier, _groupName, _groupValue) {
        let latencyData = _latencyData;
        if (_groupName && _groupValue) {
            latencyData = AnalyticsUtil.filterBy(_latencyData, (_e) => _e[_groupName] === _groupValue);
        }
        let series = [];
        if (_filterOutlier) {
            let data = {};
            for (let i = 0; i < latencyData.length; i++) {
                const current = latencyData[i];
                if (!data[current.day]) {
                    data[current.day] = [];
                }
                data[current.day].push(current.latency);
            }
            for(let day in data) {
                let latencyValues = data[day];
                let outlierResult = OutlierUtil.filterOutlier(latencyValues);
                let avg = StatisticsUtil.avg(outlierResult.cleaned);
                let outlierPercentage = outlierResult.outlier.length / (outlierResult.outlier.length + outlierResult.cleaned.length);
                const outlierText = "Outliers: "+outlierResult.outlier.length+"("+Math.round(outlierPercentage*10000)/100+"%)";
                series.push({name: _groupValue, x: new Date(day).getTime(), y: avg, text: formatSeconds(avg)+ " ("+outlierResult.cleaned.length+" Users) "+outlierText});
            }
        } else {
            for (let i = 0; i < latencyData.length; i++) {
                const current = latencyData[i];
                const latency = current.latency;
                series.push({name: _groupValue, x: new Date(current.day).getTime(), y: latency, text: formatSeconds(latency)+ " ("+current.dau+" Users)"});
            }
        }
        return {name: _groupValue, data: series};
    }

    static getGraphData(ctx, _props, _cb) {
        let filter = JSON.parse(JSON.stringify(_props.filter));
        if (_props.dateSelection) {
            filter.day = {from: _props.dateSelection.start, to: _props.dateSelection.end};
        }
        const grouping = ["day", _props.group];
        if (_props.filterOutlier === true) {
            grouping.push("user_id");
        }
        filter.latency = {from:0 , to: 300};
        ctx.sendAsync("latency","ad_latency_v4",["cardinality:user_id:dau","avg:latency:latency"],grouping, filter);
        return ctx.waitForCompletion((_err, _data) => {
            if (_err) {
                _cb(_err);
            } else {
                let latencyData = _data.latency.result;
                let groups = AnalyticsUtil.getDistinct(latencyData, _props.group);
                let series = [];
                if (groups.length > 0) {
                    for(let i = 0; i < groups.length; i++) {
                        let data = AdLatency_Daily.calcAdLatency(latencyData, _props.filterOutlier, _props.group, groups[i]);
                        series.push(data);
                    }
                } else {
                    let data = AdLatency_Daily.calcAdLatency(latencyData, _props.filterOutlier);
                    series.push(data);
                }
                let graphData = {
                    chart : {type: "line"},
                    legend: {enabled: groups.length > 1},
                    series : series,
                };
                return _cb(null, graphData);
            }
        });
    }

    static getXAxis() {
        return {type: "datetime", crosshair: true};
    }

    static getYAxis() {
        return YAxisFormatTime();
    }

    static getTooltip() {
        return {
            split:true,
            formatter : function() {
                let result = [formatGermanDate(new Date(this.x))];
                for(let i = 0; i < this.points.length; i++) {
                    result.push(this.points[i].point.text);
                }
                return result;
            }
        };
    }
}

export default CachedGraphV2(AdLatency_Daily, HighChartsGraph);